// getShouldShowFooter.js
'use strict';
import { matchPath } from 'react-router-dom';

import getIsMatchedPathname from '../resource/getIsMatchedPathname.js';
import {
  ManageProfileType,
  ProfileListPublishStatus,
} from './profileConstants.js';

export const BOTTOM_NAVIGATION_PATHS = [
  '/',
  '/video',
  '/story',
  '/livestream',
  '/feed',
  '/chat',
  '/shorts',
  '/shorts/:messageId',
  '/shorts/ad/:cta',
  `/shorts/:messageId/${ProfileListPublishStatus.DRAFT}`,
  '/following',
  '/explore',
  '/user/:userId',
  '/user/:userId/:listType',
  '/user/:userId/:listType/:publishStatus',
  '/u/:username',
  '/u/:username/:listType',
  '/u/:username/:listType/:publishStatus',
  '/category-overview',
  '/category/:categoryId',
  '/category/:categoryId/:listType',
  '/hashtag/:hashtag/:type',
  '/post/:messageId',
  '/story/:messageId',
];

/**
 * Get should show bottom nanvigation footer
 * @param {string} {pathname} - location pathname.
 * @return {boolean} Return true means should show footer.
 */
export const getShouldShowBottomNavigation = ({ pathname } = {}) => {
  return BOTTOM_NAVIGATION_PATHS.some(path => {
    const result = matchPath(path, pathname);
    if (result == null) {
      return false;
    }
    const isOnLivestreamDetail = getIsMatchedPathname({
      pathname,
      dataKey: 'isOnLivestreamDetail',
    });
    if (isOnLivestreamDetail) {
      return false;
    }
    return true;
  });
};

export const FOOTER_PATHS = [
  '/',
  '/explore',
  '/following',
  '/story',
  '/livestream',
  '/video',
  '/feed',
  '/user/:userId',
  '/user/:userId/:listType',
  '/u/:username',
  '/u/:username/:listType',
  '/post/:messageId',
  '/settings/journal',
  '/archive',
  '/settings',
  `/manage-profile/${ManageProfileType.ACCOUNT}`,
  `/manage-profile/${ManageProfileType.MANAGE}`,
  '/settings/auto-addvalue',
  '/settings/referral',
  '/settings/faq',
  '/flix-categories/:category',
  '/story-categories/:category',
  '/shorts-categories/:category',
];

/**
 * Get should show footer
 * @param {string} {pathname} - location pathname.
 * @param {string} {messageLayoutType} - message layout type from hooks/useMessageDetailType.js.
 * @return {boolean} Return true means should show footer.
 */
export const getShouldShowFooter = ({ pathname, messageLayoutType } = {}) => {
  if (!pathname) {
    return false;
  }
  return FOOTER_PATHS.some(path => {
    const result = matchPath(path, pathname);
    if (result == null) {
      return false;
    }
    const isOnLivestreamDetail = getIsMatchedPathname({
      pathname,
      dataKey: 'isOnLivestreamDetail',
    });
    if (isOnLivestreamDetail) {
      return false;
    }
    const isOnPostDetail = getIsMatchedPathname({
      pathname,
      dataKey: 'isOnPostDetail',
    });
    if (isOnPostDetail && 'flix' !== messageLayoutType) {
      return false;
    }
    return true;
  });
};

export const SHORT_PATHS = [
  '/shorts',
  '/shorts/:messageId',
  `/shorts/:messageId/${ProfileListPublishStatus.DRAFT}`,
  '/shorts/ad/:cta',
];
